import Users from "@/views/AdminPanel/Users.vue";
import AppVersionUpdates from "@/views/AdminPanel/AppVersionUpdates.vue";
import CreateAppVersionUpdates from "@/views/AdminPanel/CreateAppVersionUpdates.vue";
import EditAppVersionUpdates from "@/views/AdminPanel/EditAppVersionUpdates.vue";
import AppVersionConfirmationHistory from "@/views/AdminPanel/AppVersionConfirmationHistory.vue";
//import Companies from "@/views/AdminPanel/Companies.vue";
//import EditCompany from "@/views/AdminPanel/EditCompany.vue";
import EditUser from "@/views/AdminPanel/EditUser.vue";
import Offers from "@/views/AdminPanel/Offers.vue";
import OffersCreate from "@/views/AdminPanel/OfferCreate.vue";
import OfferEdit from "@/views/AdminPanel/OfferEdit.vue";
import Options from "@/views/Shop/Options/Options.vue";
import OptionsCreate from "@/views/Shop/Options/OptionsCreate.vue";
import OptionsEdit from "@/views/Shop/Options/OptionsEdit.vue";
const routes = [
    {
        path: "/secure/admin/users",
        name: "AdminUsers",
        component: Users,
    },
    {
        path: "/secure/admin/app-version-updates",
        name: "AppVersionUpdates",
        component: AppVersionUpdates
    },
    {
        path: "/secure/admin/app-version-updates/create",
        name: "CreateAppVersionUpdates",
        component: CreateAppVersionUpdates
    },
    {
        path: "/secure/admin/app-version-updates/:uuid/edit",
        name: "EditAppVersionUpdates",
        component: EditAppVersionUpdates
    },
    {
        path: "/secure/admin/app-version-updates/:uuid/confirmation-history",
        name: "AppVersionConfirmationHistory",
        component: AppVersionConfirmationHistory
    },
    /*   {
      path: "/secure/admin/companies",
      name: "AdminCompanies",
      component: Companies,
    }, */
    {
        path: "/secure/admin/edit-user/:user_uuid",
        name: "EditUser",
        component: EditUser,
    },
    /*   {
      path: "/secure/admin/edit-company/:company_uuid",
      name: "EditCompanies",
      component: EditCompany,
    }, */
    {
        path: "/secure/shop/offers",
        name: "Offers",
        component: Offers,
    },
    {
        path: "/secure/shop/offers/create",
        name: "OffersCreate",
        component: OffersCreate,
    },
    {
        path: "/secure/shop/offers/edit/:offer_uuid",
        name: "OfferEdit",
        component: OfferEdit,
    },
    {
        path: "/secure/shop/options",
        name: "OptionsList",
        component: Options,
    },
    {
        path: "/secure/shop/options/create",
        name: "OptionsCreate",
        component: OptionsCreate,
    },
    {
        path: "/secure/shop/options/edit/:option_uuid",
        name: "OptionsEdit",
        component: OptionsEdit,
    },
];
export default routes;
